<template>

    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('delete', 'Delete') }}</h5>
        </div>
        <div class="modal-body ">
            <div class="modal-info">
                <img loading="lazy"  rel="preload"   src="@/assets/images/exit-clickbet-icon.webp" alt="delete-account-icon">
            </div>
            <div class="thm-heading d-inline-block text-center m-auto w-100">
                <h3>{{ $t('delete-account', 'Delete Account') }}?</h3>
                <p>{{ $t('are-you-sure-want-to-delete-this-acoount', 'Are you sure you want to, delete this account') }}?</p>
            </div>
            <!-- <div class="back-modal-footer ">
                <a @click="$emit('close')" id="closeBtn" class="btn btn-danger" data-bs-dismiss="modal">
                    {{ $t('no', 'No') }}
                </a>
                <a  @click="deleteServiceCall()" class="btn place-but">{{ $t('yes', 'Yes') }}</a>
            </div> -->
            <div class="forgot-btn-box">
                <a @click="$emit('close')" id="closeBtn" class="back-btn btn" data-bs-dismiss="modal">
                    {{ $t('no', 'No') }}
                </a>
                <a  @click="deleteServiceCall()" class="get-otp-btn text-white fw-bolder btn">{{ $t('yes', 'Yes') }}</a>
            </div>
        </div>
        
    </div>
</template>

<script>
import { removeAccount } from '../services/withdrawDetails'
export default {
    name: 'DeleteAccount',
    props: ['item'],
    emits: ['close', 'yes-click'],    
    methods:{
        async deleteServiceCall() {
            let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
        }
    },
};
</script>